import { useCallback, useState, type RefObject } from "react";
import type { MapRef } from "react-map-gl/maplibre";
import { useT } from "../i18n";

type Pos = { lat: number; lng: number };

/**
 * Geolokace uživatele: zjistí polohu, vycentruje mapu a předá pozici dál
 * přes `onLocated` (např. pro nalezení nejbližšího WC). Hook záměrně nezná
 * seznam WC ani výběr – to drátuje volající.
 */
export function useGeolocation(mapRef: RefObject<MapRef | null>) {
  const t = useT();
  const [userPos, setUserPos] = useState<Pos | null>(null);
  const [locating, setLocating] = useState(false);

  const locate = useCallback(
    (onLocated?: (pos: Pos) => void) => {
      if (!navigator.geolocation) {
        alert(t("geo.unsupported"));
        return;
      }
      setLocating(true);
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          const pos = { lat: coords.latitude, lng: coords.longitude };
          setUserPos(pos);
          mapRef.current?.flyTo({ center: [pos.lng, pos.lat], zoom: 16 });
          onLocated?.(pos);
          setLocating(false);
        },
        (err) => {
          setLocating(false);
          alert(t("geo.failed", { error: err.message }));
        },
        { enableHighAccuracy: true, timeout: 10_000 },
      );
    },
    [mapRef, t],
  );

  return { userPos, locating, locate };
}
